
import VueSlider from "vue-slider-component/dist-css/vue-slider-component.umd.min.js";
import "vue-slider-component/dist-css/vue-slider-component.css";
import "~/assets/calculator-slider-styles.css";

const MOCK_CAPACITY = {
  vps: [
    { en_title: "CPU", fa_title: "پردازنده", unit: "هسته", min: 1, max: 32 },
    { en_title: "RAM", fa_title: "حافظه", unit: "گیگابایت", min: 1, max: 128 },
    {
      en_title: "Storage",
      fa_title: "دیسک",
      unit: "گیگابایت",
      min: 20,
      max: 1000,
    },
    {
      en_title: "Traffic",
      fa_title: "ترافیک",
      unit: "گیگابایت",
      min: 100,
      max: 10000,
    },
  ],
  vpc: [
    { en_title: "CPU", fa_title: "پردازنده", unit: "هسته", min: 1, max: 64 },
    { en_title: "RAM", fa_title: "حافظه", unit: "گیگابایت", min: 1, max: 256 },
    {
      en_title: "Storage",
      fa_title: "دیسک",
      unit: "گیگابایت",
      min: 20,
      max: 2000,
    },
    {
      en_title: "Traffic",
      fa_title: "ترافیک",
      unit: "گیگابایت",
      min: 100,
      max: 10000,
    },
  ],
};

export default {
  props: ["cta", "type"],
  components: { VueSlider },
  data() {
    return {
      plans: { capacity: [] },
      calculator: {},
    };
  },
  computed: {
    thePlans() {
      if (!this.plans.capacity?.length) return [];
      return this.plans.capacity.filter((x) => {
        return x.min < x.max;
      });
    },
  },
  created() {
    const planType = this.type === "دیتاسنتر" ? "vpc" : "vps";
    this.plans.capacity = MOCK_CAPACITY[planType];
    this.plans.capacity.forEach((x) => {
      this.$set(this.calculator, x.en_title, x.min);
    });
  },
  mounted() {
    var sliderElements = document.querySelectorAll(".vue-slider-dot-hover");
    sliderElements.forEach(function (sliderElement) {
      sliderElement.setAttribute("aria-label", "Calculator");
    });
  },
};
